import { useState } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Checkbox,
} from '@design-system';

interface ShopInsuranceAcknowledgmentOverlayProps {
  open: boolean;
  onAcknowledge: (dontShowAgain: boolean) => void;
}

export function ShopInsuranceAcknowledgmentOverlay({
  open,
  onAcknowledge,
}: ShopInsuranceAcknowledgmentOverlayProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  function handleAcknowledge() {
    onAcknowledge(dontShowAgain);
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="shop-insurance-acknowledgement-overlay">
        <AlertDialogHeader>
          <AlertDialogTitle>Important Notice</AlertDialogTitle>
          <AlertDialogDescription className="text-foreground text-sm">
            Initial values provided are close approximations, typically within 1% of the actual
            values. For the true value, click on "Create Quote" for the policies you're interested
            in.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="dontShowAgain"
            checked={dontShowAgain}
            onCheckedChange={checked => setDontShowAgain(checked as boolean)}
          />
          <label
            htmlFor="dontShowAgain"
            className="text-foreground cursor-pointer text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Don't show this again
          </label>
        </div>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={handleAcknowledge}
            className="w-full"
            data-testid="shop-insurance-acknowledgement-overlay-button"
          >
            Acknowledge
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
